import { useEffect, useRef } from "react";

function useWebAppState(onActive, onHide) {
	const onActiveRef = useRef(onActive);
	const onHideRef = useRef(onHide);

	useEffect(() => {
		onActiveRef.current = onActive;
		onHideRef.current = onHide;
	}, [onActive, onHide]);

	// useEffect(() => {
	//     onActiveRef.current && onActiveRef.current();
	// }, [])

	useEffect(() => {
		const handleVisibilityChange = () => {
			if (document.hidden) {
				onHideRef.current?.();
			} else {
				onActiveRef.current?.();
			}
		};

		const handleBeforeUnload = () => {
			onHideRef.current?.();
		};

		document.addEventListener("visibilitychange", handleVisibilityChange);
		window.addEventListener("beforeunload", handleBeforeUnload);

		return () => {
			document.removeEventListener("visibilitychange", handleVisibilityChange);
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, []);
}

export default useWebAppState;
